import { createContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [Token, setToken] = useState(localStorage.getItem('accessToken') || null);
  const [Authorised, setAuthorised] = useState(!!(localStorage.getItem('accessToken')));
  const [UserType, setUserType] = useState('');
  const [User, setUser] = useState(null);
  const [Permissions, setPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Initial load from localStorage if available
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        setUserType(parsedUser.userType);

        // Extract permissions from user object or JWT if needed
        // Assuming permissions array is directly on the user object from login response
        if (parsedUser.permissions && Array.isArray(parsedUser.permissions)) {
          setPermissions(parsedUser.permissions);
        }

        if (Token) {
          setAuthorised(true);
        }
      } catch (e) {
        console.error("Failed to parse stored user", e);
        localStorage.removeItem('user');
      }
    }
    // Auth check complete
    setIsLoading(false);
  }, [Token]);

  const hasPermission = (permissionName) => {
    if (!User || !Permissions) return false;
    // Admins or specific roles might have 'all' permission or similar wildcard
    if (Permissions.includes('all') || Permissions.includes('*')) return true;

    //direct match
    if (Permissions.includes(permissionName)) return true;

    //module-level wildcard match
    const [module] = permissionName.split('.');
    if (module && Permissions.includes(`${module}.all`)) return true;

    return false;
  };

  const hasRole = (roleName) => {
    if (!User?.role) return false;
    return User.role.name === roleName;
  };

  const loginSuccess = (accessToken, userData) => {
    setToken(accessToken);
    setUser(userData);
    setUserType(userData.userType);
    setAuthorised(true);

    if (userData.permissions) {
      setPermissions(userData.permissions);
    }

    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    setPermissions([]);
    setAuthorised(false);
    setUserType('');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
  };

  return (
    <AuthContext.Provider value={{
      Token,
      setToken,
      Authorised,
      setAuthorised,
      UserType,
      setUserType,
      User,
      Permissions,
      hasPermission,
      hasRole,
      loginSuccess,
      logout,
      isLoading
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
